<dx-popup
  title="Conformité de la statistique egalim"
  [(visible)]="isDisplayed"
  width="900"
  height="700"
  resizeEnabled="true">
  <yo-indicateur-egalim *ngIf="!isLoading"
                        [values]="[data.pourcentageDurable, data.pourcentageBio, data.pourcentageMontantProduitsPoissonViande]"
                        [inputSeuils]="data.seuils"
                        [isConformeEgalim]="data.isConforme"
                        [subtitle]="data.annee ? data.annee + '<br>' + data.pointTeledeclarationLibelle : 'Chargement en cours'"
                        [titleText]="customizeTextLabelGaugeEgalim"
                        [tooltipText]="customizeTooltipGaugeEgalim"
                        [legendText]="customizeTextGaugeEgalim"
                        (onChangeSeuil)="onChangeSeuil($event)">
  </yo-indicateur-egalim>
  <div *ngIf="isLoading" id="loading-container">
    <div id="indicator-container">
      <dx-load-indicator></dx-load-indicator>
      <span>Chargement en cours ...</span>
    </div>
  </div>
</dx-popup>
